const ClubEquipmentTypeEnum = {
    B: 'Ball Machine',
    L: 'Balls',
    C: 'Cones',
    P: 'Props',
    R: 'Racquet',
    O: 'Other'
};

export default ClubEquipmentTypeEnum